import { format } from 'date-fns';

import { WizardConfig } from '@/components/common/mass-edit-wizard/config';
import {
  shipmentCategoryOptions,
  shipmentStatusOptions,
  shippingMethodOptions,
} from '@/constants';
import { ShipmentListItem } from '@/services/shipping/types';

export const shipmentWizardConfig: WizardConfig = {
  fields: {
    owner: {
      label: 'account.account',
      type: 'object',
      mapValue: (formValue: any, row: ShipmentListItem) => {
        if (!formValue) return undefined;
        const ownerId =
          typeof formValue === 'string' ? formValue : formValue.id;
        return {
          ownerId,
          owner: {
            ...row.owner,
            id: ownerId,
            code:
              typeof formValue === 'string' ? row.owner?.code : formValue.code,
            name:
              typeof formValue === 'string' ? row.owner?.name : formValue.name,
          },
        };
      },
    },
    shipFromSite: {
      label: 'shipping.shipFromSite',
      type: 'object',
      mapValue: (formValue: any, row: ShipmentListItem) => {
        if (!formValue) return undefined;
        const shipFromSiteId =
          typeof formValue === 'string' ? formValue : formValue.id;
        return {
          shipFromSiteId,
        };
      },
    },
    shipTo: {
      label: 'shipping.shipTo',
      type: 'object',
      mapValue: (formValue: any, row: ShipmentListItem) => {
        if (!formValue) return undefined;
        const shipToId =
          typeof formValue === 'string' ? formValue : formValue.id;
        return {
          shipToId,
          shipTo: typeof formValue === 'object' ? formValue : row.shipTo,
        };
      },
      formatValue: (formValue: any) => {
        if (!formValue) return '';
        if (typeof formValue === 'object' && formValue.name)
          return formValue.name;
        return String(formValue);
      },
    },
    packedBy: {
      label: 'shipping.packedBy',
      type: 'object',
      mapValue: (formValue: any, row: ShipmentListItem) => {
        if (!formValue) return undefined;
        const packedById =
          typeof formValue === 'string' ? formValue : formValue.id;
        return {
          packedById,
          packedBy: {
            ...row.packedBy,
            id: packedById,
            name:
              typeof formValue === 'string'
                ? row.packedBy?.name
                : formValue.name,
          },
        };
      },
      formatValue: (formValue: any) => {
        if (!formValue) return '';
        if (typeof formValue === 'object' && formValue.name)
          return formValue.name;
        return String(formValue);
      },
    },
    date: {
      label: 'common.date',
      type: 'date',
      mapValue: (formValue: any) => {
        if (!formValue) return undefined;
        return formValue instanceof Date ? formValue.toISOString() : formValue;
      },
      formatValue: (value: any) => {
        if (!value) return '';
        const date = typeof value === 'string' ? new Date(value) : value;
        return Number.isNaN(date) ? String(value) : format(date, 'MM/dd/yyyy');
      },
    },
    needByDate: {
      label: 'shipping.needByDate',
      type: 'date',
      mapValue: (formValue: any) => {
        if (!formValue) return undefined;
        return formValue instanceof Date ? formValue.toISOString() : formValue;
      },
      formatValue: (value: any) => {
        if (!value) return '';
        const date = typeof value === 'string' ? new Date(value) : value;
        return Number.isNaN(date) ? String(value) : format(date, 'MM/dd/yyyy');
      },
    },
    tank: {
      label: 'shipping.tankIncubator',
      type: 'string',
    },
    trackingNumber: {
      label: 'shipping.trackingNumber',
      type: 'string',
    },
    shippingMethod: {
      label: 'shipping.shippingMethod',
      type: 'number',
      formatValue: (value: any) => {
        const option = shippingMethodOptions.find((opt) => opt.value === value);
        return option ? option.label : String(value);
      },
    },
    billStatus: {
      label: 'billing.billStatus',
      type: 'number',
    },
    shipmentCategory: {
      label: 'shipping.shipmentCategory',
      type: 'number',
      formatValue: (value: any) => {
        const option = shipmentCategoryOptions.find(
          (opt) => opt.value === value,
        );
        return option ? option.label : String(value);
      },
    },
    shipmentStatus: {
      label: 'shipping.shipmentStatus',
      type: 'number',
      formatValue: (value: any) => {
        const option = shipmentStatusOptions.find((opt) => opt.value === value);
        return option ? option.label : String(value);
      },
    },
    shipName: {
      label: 'shipping.shipName',
      type: 'string',
    },
    shipCity: {
      label: 'shipping.shipCity',
      type: 'string',
    },
    shipState: {
      label: 'shipping.shipState',
      type: 'string',
    },
    shipZip: {
      label: 'shipping.shipZip',
      type: 'string',
    },
    comment: {
      label: 'common.comment',
      type: 'string',
    },
  },
  excludeKeys: ['id', 'shipmentNumber', 'createdBy', 'createdOn'],
  getRowDisplayName: (row: ShipmentListItem) =>
    `Shipment #${row.shipmentNumber}`,
};
